"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fieldSizeDefaultProps = exports.fieldSizePropTypes = exports.default = exports.FieldSize = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var FieldSize;
exports.FieldSize = FieldSize;

(function (FieldSize) {
  FieldSize["DEFAULT"] = "DEFAULT";
  FieldSize["SMALL"] = "SMALL";
})(FieldSize || (exports.FieldSize = FieldSize = {}));

var _default = FieldSize;
exports.default = _default;
var fieldSizePropTypes = {
  size: _propTypes.default.oneOf(['DEFAULT', 'SMALL'])
};
exports.fieldSizePropTypes = fieldSizePropTypes;
var fieldSizeDefaultProps = {
  size: 'DEFAULT'
};
exports.fieldSizeDefaultProps = fieldSizeDefaultProps;